import React from 'react';
import { Form, Select } from 'antd';
import { NamePath } from 'rc-field-form/lib/interface';

export type SelectValue<T> = {
  value: T;
  display: string;
};

export type SelectInputProps<T> = {
  name: NamePath;
  label?: string;
  required?: boolean;
  options: SelectValue<T>[];
  onChange?: (value: T) => void;
  disabled?: boolean;
};

export function SelectInput<T>(props: SelectInputProps<T>) {
  const handleChange = (value: T) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return (
    <Form.Item name={props.name} label={props.label} rules={[{ required: props.required, message: `${props.label} is required` }]}>
      <Select getPopupContainer={(trigger) => trigger.parentElement} onChange={handleChange} disabled={props.disabled}>
        {props.options.map((item, index) => (
          <Select.Option key={`select-${props.name}-${index}`} value={item.value}>
            {item.display}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}
